import { render } from "./IncreasingHours.vue?vue&type=template&id=21a80814&scoped=true"
import script from "./IncreasingHours.vue?vue&type=script&lang=js"
export * from "./IncreasingHours.vue?vue&type=script&lang=js"

import "./IncreasingHours.vue?vue&type=style&index=0&id=21a80814&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a80814"]])

export default __exports__